const totalPages = (total: number, pageSize: number): number => {
  if (total % pageSize === 0) {
    return total / pageSize;
  }

  return parseInt((total / pageSize).toString(), 10) + 1;
};

totalPages.displayName = 'TotalPages';

export default totalPages;
